import React from 'react';
import RichText from '../';
import { StyledRichTextContainer } from './styles';

const StyledRichText = ({ content, ...otherProps }) => {
  return (
    <StyledRichTextContainer {...otherProps}>
      <RichText content={content} />
    </StyledRichTextContainer>
  );
};

export default StyledRichText;
